import React from "react";

export default class GameInstance {

    static MONEY_RESOURCES = ['income_active', 'income_passive','expense', 'investment', 'initial_reserve'];

    profileProperty = 'PROFILE_KIND';
    profileHousingProperty = 'PROFILE_HOUSING';
    profileHousingInsuranceProperty = 'PROFILE_HOUSING_INSURANCE';
    profileFoodProperty = 'PROFILE_FOOD';
    profileTransportationProperty = 'PROFILE_TRANSPORTATION';
    profileTransportationInsuranceProperty = 'PROFILE_TRANSPORTATION_INSURANCE';

    data = {};

    constructor(data) {
        this.data = data;
        this.id = data.id;
        this.properties = data.properties;
        this.current_node = data.current_node;
        this.nodes = data.nodes;
        this.answers = data.answers;
        this.type = data.type;
    }

    getType() {
        return this.type;
    }

    getProperty(property) {
        return this.properties[property];
    }

    getProfile() {
        return this.properties[this.profileProperty];
    }

    getProfileProperty(property) {
        return this.getProfile()['properties'][property];
    }

    getHousing() {
        let selected = this.getProperty(this.profileHousingProperty);

        if (selected === undefined || selected === null) {
            return undefined;
        }

        return this.getProfileProperty('dwelling')['options'][selected];
    }

    getFood() {
        let selected = this.getProperty(this.profileFoodProperty);

        if (selected === undefined || selected === null) {
            return undefined;
        }

        return this.getProfileProperty('food')['options'][selected];
    }

    getTransportation() {
        let housing = this.getHousing();
        let selected = this.getProperty(this.profileTransportationProperty);
        let transportation = this.getProfileProperty('transportation');

        if (!housing || selected === undefined || selected === null) {
            return undefined;
        }

        let localityId = housing['locality'];
        let location = transportation.find((location) => localityId === location['id']);

        return location['options'][selected];
    }

    getHousingInsurance() {
        let housing = this.getHousing();
        let selected = this.getProperty(this.profileHousingInsuranceProperty);

        if (!housing || selected === undefined || selected === null) {
            return undefined;
        }

        return housing['insurance'][selected];
    }

    getTransportationInsurance() {
        let transportation = this.getTransportation();
        let selected = this.getProperty(this.profileTransportationInsuranceProperty);

        if (!transportation|| selected === undefined || selected === null) {
            return undefined;
        }

        return transportation['insurance'][selected];
    }

    getCurrentNodeTitle() {
        switch (this.getCurrentNodeType()) {
            case "Nodes::IntroNode": return "Úvod";
            case "Nodes::Round01Node": return "Profil";
            case "Nodes::Round02Node": return "Výdaje";
            case "Nodes::Round03Node": return "Vánoce a rezervy";
            case "Nodes::FinalNode": return "Konec hry";
        }
    }

    static getCategoryTitle(category) {
        switch (category) {
            case "domacnost": return "Domácnost";
            case "pece_o_sebe": return "Péče o sebe";
            case "komunikace_a_media": return "Komunikace a média";
            case "zdravi_a_sport": return "Zdraví a sport";
            case "vzdelavani_a_rozvoj": return "Vzdělávání a rozvoj";
            case "pece_o_zvire": return "Péče o zvíře";
            case "zabava": return "Zábava";
            case "privydelky": return "Přivýdělky";
            case "vanoce": return "Vánoce";
            case "financni_rezervy_a_investice": return "Finanční rezervy a investice";
            case "co_zivot_dal": return "Co život dal";
            case "specific": return "Po 1. kole";
        }
    }

    getRegionTitle() {
        return GameInstance.getRegionTitle(this.getProperty('region'));
    }

    static getRegionTitle(region) {
        switch (region) {
            case "praha": return "Hlavní město Praha";
            case "stredocesky": return "Středočeský kraj";
            case "jihocesky": return "Jihočeský kraj";
            case "plzensky": return "Plzeňský kraj";
            case "karlovarsky": return "Karlovarský kraj";
            case "ustecky": return "Ústecký kraj";
            case "liberecky": return "Liberecký kraj";
            case "kralovohradecky": return "Královéhradecký kraj";
            case "pardubicky": return "Pardubický kraj";
            case "vysocina": return "Kraj Vysočina";
            case "jihomoravsky": return "Jihomoravský kraj";
            case "olomoucky": return "Olomoucký kraj";
            case "moravskoslezsky": return "Moravskoslezský kraj";
            case "zlinsky": return "Zlínský kraj";
        }
    }

    getSchoolKindTitle() {
        return GameInstance.getSchoolKindTitle(this.getProperty('school_kind'));
    }

    static getSchoolKindTitle(school_kind) {
        switch (school_kind) {
            case "zs-1": return "Základní škola - 1. stupeň";
            case "zs-2": return "Základní škola - 2. stupeň";
            case "ss": return "Střední škola";
            case "dd": return "Dětský domov";
            case "po": return "Partnerská organizace";
        }
    }

    getCurrentNodeType() {
        return this.current_node && this.current_node['type'];
    }

    getActiveEvent() {
        return this.data && this.data.active_event;
    }

}